import { useState } from 'react';
import { API } from 'aws-amplify';
import { useSnackbar } from 'notistack';
import {
  Box,
  IconButton,
  Button,
  TextField,
  Modal,
  Paper,
  Tooltip,
  Grid,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import useAuth from '../../../hooks/useAuth';
import XIcon from '../../../icons/X';
import PlusIcon from '../../../icons/Plus';

const statusOptions = [
  {
    label: 'Inactive',
    value: 'inactive'
  },
  {
    label: 'Active',
    value: 'active'
  }
];

const rolesOptions = [
  {
    label: 'Admin',
    value: 'admin'
  },
  {
    label: 'User',
    value: 'user'
  }
];

const rdptAdminRolesOptions = [
  {
    label: 'RDPT Admin',
    value: 'rdpt_admin'
  }
];

const apiName = 'surveyor-API';

export default function AddUserModal(props) {
  const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const { get } = props;
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    console.log('close');
    setOpen(false);
    get();
  };

  const createUser = async () => {
    console.log(document.getElementById('email').value);
    if (document.getElementById('email').value !== '') {
      const path = (user.role === 'rdpt_admin' ? '/admin/user' : '/user');
      console.log(user.role);
      console.log(path);
      console.log(user);
      const param = {
        body: {
          status: (document.getElementById('status').value !== '' ? document.getElementById('status').value : 'active'),
          first_name: (document.getElementById('first_name').value !== '' ? document.getElementById('first_name').value : 'New User'),
          last_name: (document.getElementById('last_name').value !== '' ? document.getElementById('last_name').value : 'New User'),
          email: document.getElementById('email').value,
          role: (document.getElementById('roles').value !== '' ? document.getElementById('roles').value : 'user')
        }
      };

      const response = await API.post(apiName, path, param);
      if (response) {
        handleClose();
      } else {
        console.log(response);
        enqueueSnackbar('User Not Created!', {
          anchorOrigin: {
            horizontal: 'right',
            vertical: 'top'
          },
          autoHideDuration: 3000,
          variant: 'warning'
        });
      }
    } else {
      enqueueSnackbar('Email Address Required!', {
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'top'
        },
        autoHideDuration: 3000,
        variant: 'warning'
      });
      document.getElementById('email').focus();
    }
  };
  const body = (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        minHeight: '100%',
        p: 3
      }}
    >
      <Paper
        elevation={8}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          margin: 3,
          minHeight: 100,
          mx: 'auto',
          outline: 'none',
          width: 600
        }}
      >
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            px: 2,
            py: 1
          }}
        >
          <Typography
            variant="h6"
            color="textPrimary"
          >
            Create User
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton>
            <XIcon
              fontSize="small"
              onClick={handleClose}
            />
          </IconButton>
        </Box>
        <Box
          sx={{
            pb: 3,
            pt: 2,
            px: 2
          }}
        >
          <form onSubmit={(event) => event.preventDefault()}>
            <Box sx={{ mt: 2 }}>
              <TextField
                fullWidth
                placeholder="Email"
                label="Email"
                name="email"
                id="email"
                variant="outlined"
              />
            </Box>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                <Box sx={{ mt: 2 }}>
                  <TextField
                    fullWidth
                    placeholder="First Name"
                    label="First Name"
                    name="first_name"
                    id="first_name"
                    variant="outlined"
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <Box sx={{ mt: 2 }}>
                  <TextField
                    fullWidth
                    placeholder="Last Name"
                    label="Last Name"
                    name="last_name"
                    id="last_name"
                    variant="outlined"
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                <Box sx={{ mt: 2 }}>
                  <TextField
                    fullWidth
                    label="Status"
                    name="status"
                    id="status"
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    defaultValue="active"
                  >
                    {statusOptions.map((status) => (
                      <option
                        key={status.value}
                        value={status.value}
                      >
                        {status.label}
                      </option>
                    ))}
                  </TextField>
                </Box>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <Box sx={{ mt: 2 }}>
                  {user.role === 'rdpt_admin'
                    ? (
                      <TextField
                        fullWidth
                        label="Roles"
                        name="roles"
                        id="roles"
                        select
                        SelectProps={{ native: true }}
                        variant="outlined"
                      >
                        {rdptAdminRolesOptions.map((roles) => (
                          <option
                            key={roles.value}
                            value={roles.value}
                          >
                            {roles.label}
                          </option>
                        ))}
                      </TextField>
                    ) :
                    (
                      <TextField
                        fullWidth
                        label="Roles"
                        name="roles"
                        id="roles"
                        select
                        SelectProps={{ native: true }}
                        variant="outlined"
                      >
                        {rolesOptions.map((roles) => (
                          <option
                            key={roles.value}
                            value={roles.value}
                          >
                            {roles.label}
                          </option>
                        ))}
                      </TextField>
                    )}
                </Box>
              </Grid>
            </Grid>
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <Button
                color="secondary"
                sx={{ m: 2 }}
                type="submit"
                variant="contained"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                sx={{ m: 2 }}
                type="submit"
                variant="contained"
                onClick={createUser}
              >
                Save User
              </Button>
            </Box>
          </form>
        </Box>
      </Paper>
    </Box>
  );

  return (
    <div>
      <Tooltip title="Add a User">
        <Button
          sx={{
            backgroundColor: 'primary.main',
            mr: 3,
            '&:hover': {
              backgroundColor: 'primary.dark'
            }
          }}
          size="small"
          startIcon={<PlusIcon />}
          variant="contained"
          onClick={handleOpen}
        >
          Add User
        </Button>
      </Tooltip>
      <Modal
        open={open}
        onClose={handleClose}
      >
        {body}
      </Modal>
    </div>
  );
}

AddUserModal.propTypes = {
  get: PropTypes.func.isRequired
};
